/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: zxf
 * @LastEditTime: 2022-11-22 16:20:49
 * @Description: 检测设备管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const xfsbService = {

  // 新增
  saveXfsb: (fd) => { return axios.post(`${iffApi}/xfjc/jcsb`, fd); },

  // 更新
  updateXfsb: (fd) => { return axios.put(`${iffApi}/xfjc/jcsb`, fd); },

  // 消防设备查询
  queryXfsb: (params) => { return axios.get(`${iffApi}/xfjc/jcsb`, { params: params }); },

  // 检测点查询
  getJcdByJcnrId: (id) => { return axios.get(`${iffApi}/xfjc/jcsb/jcd/${id}`); },

  // 获取设备详情信息
  getXfsbDetail: (id) => { return axios.get(`${iffApi}/xfjc/jcsb/${id}`); },

  // 消防设备作废
  deleteXfsb: (id) => { return axios.delete(`${iffApi}/xfjc/jcsb/${id}`); },

  // 消防设备作废
  deleteXfsbList: (params) => { return axios.put(`${iffApi}/xfjc/jcsb/delete`, params); },

  // 获取设备其他说明
  getSbqtsm: (xmId) => { return axios.get(`${iffApi}/xfjc/jcsb/${xmId}/qtsm`); },

  // 保存设备其他说明
  saveSbqtsm: (params) => { return axios.post(`${iffApi}/xfjc/jcsb/qtsm`, params); },

  // 设备文件上传
  importXfsbFile: (id, file) => { return axios.post(`${iffApi}/xfjc/jcsb/${id}/import`); },

  // 设备模板下载
  exportSbmbFile: () => { return axios.get(`${iffApi}/xfjc/jcsb/export/mb`, { responseType: 'blob' }); }
};
